import { render, staticRenderFns } from "./add-or-update.vue?vue&type=template&id=e963dc7c&scoped=true&"
import script from "./add-or-update.vue?vue&type=script&lang=js&"
export * from "./add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./add-or-update.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./add-or-update.vue?vue&type=style&index=1&id=e963dc7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e963dc7c",
  null
  
)

export default component.exports